import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'

type IComponentProps = {
  toChannelId: string
}

const ChatButton = (props: IComponentProps) => {
  return (
    <a
      className='btn btn-outline-primary btn-sm'
      aria-label='Open Chat Channel'
      href={`/chat?channel=${props.toChannelId}`}
    >
      <FontAwesomeIcon icon={['far', 'messages']} /> Chat
    </a>
  )
}

export default ChatButton
